import { styled } from '@mui/material';

import { useI18n } from '@app-velocity/i18n';
import { Page, Skeleton } from '@app-velocity/ui';

import { useGetTeamMembersQuery } from '@app-velocity/libs/teams-data-access';

import { useTeamAdminContext } from '../../../../context';
import { useUsageContext } from '../../context/useUsageContext';

const StyledSection = styled('section')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(3),
  flexDirection: 'column',
  width: '100%',
}));

const Members = styled('ul')(({ theme }) => ({
  listStyleType: 'none',
  margin: 0,
  padding: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
}));

const Member = styled('li')(({ theme }) => ({
  background: 'var(--input-input-background-color)',
  borderRadius: theme.spacing(1),
  padding: theme.spacing(4),
  display: 'flex',

  fontSize: 14,
  fontWeight: 500,
  flexDirection: 'column',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
}));

export const ByUser = () => {
  const { t } = useI18n();
  const { team } = useTeamAdminContext();
  const { simStatsByUser } = useUsageContext();
  const { data: members, isLoading } = useGetTeamMembersQuery(team.id!);

  if (isLoading)
    return (
      <>
        <Skeleton height={40} width={200} />
        <Skeleton height={100} />
        <Skeleton height={100} />
        <Skeleton height={100} />
      </>
    );

  if (!simStatsByUser) return null;

  const { userSimulations } = simStatsByUser;

  if (!userSimulations) return null;

  return (
    <StyledSection>
      <Page.SectionHeader title={t('teams:usage.simulations.member_usage')} />
      <Members>
        {members?.map((member) => (
          <Member key={member.id}>
            <span>{member.userEmail}</span>
            <span>
              {t('teams:usage.simulations.n_sims', {
                count: userSimulations[member.userId!] || 0,
              })}
            </span>
          </Member>
        ))}
      </Members>
    </StyledSection>
  );
};
